import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { Storage } from "@ionic/storage";
import { AuthserviceService } from "./httpservice/authservice.service";
import { promise } from "protractor";
import { resolve } from "dns";
import { _getStorage } from "./utils/local-storage";
import { STORAGE } from "./constant/storages";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthserviceService,
    private router: Router,
    public storage: Storage
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    return new Promise((resolve) => {
      this.storage.ready().then(() => {
        const token = _getStorage(STORAGE.ACCESS_TOKEN)
        if (token) {
          const isPass = this.authService.checkPermission(state.url);
          if (isPass) {
            resolve(true);
          } else {
            this.router.navigateByUrl("/home");
            resolve(false);
          }
        } else {
          this.router.navigateByUrl("/login");
          resolve(false);
        }
      });
    });
  }
}
